// Page « Aide » (23/10/2026) : guides d'utilisation (server/content/guides,
// même source que l'assistant). Un écran peut ouvrir directement un guide :
// sessionStorage « execpro360.guide » = identifiant du guide, puis navigation vers « aide ».
import { useState, useEffect } from "react";
import api from "../services/api";
import MarkdownView from "../components/MarkdownView";

export default function Aide({ onNavigate }) {
  const [guides, setGuides] = useState(null);
  const [current, setCurrent] = useState(null); // guide ouvert (avec son Markdown)
  const [error, setError] = useState("");

  const open = (id) => {
    setError("");
    api.help.guide(id).then(setCurrent).catch(e => setError(e.message));
  };

  useEffect(() => {
    api.help.guides().then(setGuides).catch(e => setError(e.message));
    let wanted = null;
    try { wanted = sessionStorage.getItem("execpro360.guide"); sessionStorage.removeItem("execpro360.guide"); } catch {}
    if (wanted) open(wanted);
  }, []);

  if (current) return (
    <div>
      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
        <button className="btn sm" onClick={() => setCurrent(null)}>← Tous les guides</button>
        <button className="btn sm" onClick={() => window.print()}>Imprimer</button>
      </div>
      <div className="card" style={{ padding: "20px 24px" }}>
        <MarkdownView markdown={current.markdown} />
      </div>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Aide</h2>
      </div>
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginTop: -6, marginBottom: 14 }}>
        Guides d'utilisation pas à pas. L'assistant répond avec les mêmes parcours ; une question sur l'application : support@execpro360.com.
      </p>
      {error && <div className="alert danger">{error}</div>}
      {!guides && !error && <div style={{ color: "var(--text-muted)" }}>Chargement…</div>}
      <div style={{ display: "grid", gap: 10, gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))" }}>
        {(guides || []).map(g => (
          <div key={g.id} className="card" style={{ padding: "14px 16px", cursor: "pointer" }} onClick={() => open(g.id)}>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>📘 {g.title}</div>
            <div style={{ fontSize: 12.5, color: "var(--text-muted)", lineHeight: 1.45 }}>{g.summary}</div>
          </div>
        ))}
        <div className="card" style={{ padding: "14px 16px", cursor: "pointer" }} onClick={() => onNavigate?.("nouveautes")}>
          <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>✨ Nouveautés</div>
          <div style={{ fontSize: 12.5, color: "var(--text-muted)", lineHeight: 1.45 }}>Les dernières évolutions de l'application.</div>
        </div>
      </div>
    </div>
  );
}
